export class CurrentDateModel
{
    public current_date: Date;
}